import React, {useContext} from 'react';
import cn from 'classnames';

import Typography from 'brandComponents/Typography';

import DropdownContext from '../../contexts/DropdownContext';

import {IDropdownTriggerProps} from './IDropdownTrigger';

import styles from './DropdownTrigger.module.scss';

const DropdownTrigger = ({label, customIcon, displayValue}: IDropdownTriggerProps) => {
	const {value, showMenu, handleShowMenu, disabled} = useContext(DropdownContext);

	return (
		<button
			type="button"
			className={cn('dropdown__trigger', styles['dropdown__trigger'], {
				[styles['dropdown__trigger--active']]: showMenu,
			})}
			onClick={() => !disabled && handleShowMenu(!showMenu)}
		>
			{label && <Typography variant="span" classNames={cn('dropdown__label', styles['dropdown__label'])}>
				{label}{' '}
			</Typography>}
			<Typography variant="span" classNames={cn('dropdown__value', styles['dropdown__value'])}>
				{displayValue ?? value}
			</Typography>
			{customIcon && customIcon}
		</button>
	);
};

export default DropdownTrigger;
